import { EyeClosedIcon } from '@radix-ui/react-icons';

type EmptyAlertProps = {
  title: string;
  description: string;
};

const EmptyAlert = ({ title, description }: EmptyAlertProps): JSX.Element => {
  return (
    <div className="centertxt aura">
      <div className="halo">
        <div className={`aura circle mx-auto`}>
          <EyeClosedIcon className="icon disabled h1" />
        </div>
      </div>
      <div className="mt13">
        {title && <h3>{title}</h3>}
        {description && <p>{description}</p>}
      </div>
    </div>
  );
};

export default EmptyAlert;
